
import { useEffect, useState } from "react"
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { elToast } from "../functions/Alerta"


export default function useComision() {

    const { URL: URL_MIO, SERVIDOR } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)

    const [formComision, setFormComision] = useState({
        motivo: '',
        adscripcion: 2,
        fecha_salida: '',
        fecha_regreso: '',
        tipo_viaticos: 'Anticipados',
        vehiculo_autorizado: '',
        combustible: '',
        litros: '',
        placas: '',
    })
    const [jefes, setJefes] = useState([])
    const [puesto, setPuesto] = useState('')
    const [cargando, setCargando] = useState(false)
    const [guardando, setGuardando] = useState(false)
    const [formOrigen, setFormOrigen] = useState({
        pais: 'MEX',
        estado: 'SIN',
        ciudad: 'ESCUINAPA',
    })

    const [formDestino, setFormDestino] = useState({
        pais: 'MEX',
        estado: 'SIN',
        ciudad: '',
    })

	const [show, setShow] = useState(false);

	const handleShow = () => setShow(true);


    // funciones
    function traerJefes() {
        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'buscarJefesCargo')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setJefes(r)
            })
            .catch(a => {
                alert('Hubo un error al mostrar la lista de jefes, por favor intentalo nuevamente.')
            })
            .finally(() => {
                setCargando(false)
            })

    }


    function traerPuesto() {
        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'puestoPersona')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setPuesto(r.puesto)
            })
            .catch(a => {
                alert('Hubo un error al mostrar tu puesto, por favor intentalo nuevamente.')
            })
            .finally(() => {
                setCargando(false)
            })

    }


    function guardar() {
        // validar campos

        setGuardando(true)
        let aaa = {
            ...formComision,
            funcion: 'guardarComision',
            email: objLogueado.email,
            origen: formOrigen,
            destino: formDestino,
        }

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify(aaa)
        })
            .then(res => res.json())
            .then(function (d) {
                if (d.codigo === 1) {
                    elToast(d.mensaje)
                    traerExcel(d.id)
                } else {
                    elToast(d.mensaje, 'info')
                }
            })
            .catch(a => {
                elToast("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error")
                // alert("")
            })
            .finally(() => setGuardando(false))

        // guardar
    }


    function traerExcel(id) {
        // elToast('Generando archivo...', 'esperar')

        fetch(SERVIDOR + '/funciones/exportar_comision.php?id=' + id)
            .then(response => response.blob())
            .then(blob => {
                // Crea un enlace de descarga
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'Oficio de Comision UTEsc.docx';
                link.click();
                // elToast('Archivo generado exitosamente', 'exito')
				handleShow()
            })
            .catch(e => {
                elToast('Hubo un error al generar el archivo de excel, por favor intentalo nuevamente', 'error')
            })
    }


    // useEffect
    useEffect(() => {
        traerJefes()
        traerPuesto()
        // eslint-disable-next-line
    }, [])


    return {
        formComision, setFormComision, jefes, cargando, formOrigen, setFormOrigen,
        formDestino, setFormDestino, guardar, puesto, guardando, show
    }

}

